import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetMedicineGenericNameDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/MedicineGenericName/GetDetail?` + params, null);

export const GetMedicineGenericNameList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/MedicineGenericName/GetList?` + params, null);

export const CreateMedicineGenericName = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicineGenericName/Create`, data);

export const UpdateMedicineGenericName = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicineGenericName/Update`, data);

export const DeleteMedicineGenericName = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicineGenericName/Delete`, data);






